(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    function viyaBindSlideVideos() {
  document.querySelectorAll('slideshow-slide .slide__video').forEach((video) => {
    if (video.dataset.viyaBound) return;
    video.dataset.viyaBound = 'true';
    const slide = video.closest('slideshow-slide');
    const carousel = video.closest('slideshow-component');
    if (!carousel) return;
    let active = false;
    video.addEventListener('playing', () => {
      if (active && typeof carousel.suspend === 'function') carousel.suspend();
    });
    video.addEventListener('ended', () => {
      if (!active || typeof carousel.next !== 'function') return;
      carousel.next();
      carousel.resume();
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const visible = entry.isIntersecting && entry.intersectionRatio >= 0.7;
        if (visible && !active) {
          active = true;
          video.currentTime = 0;
          video.play().catch(() => carousel.resume?.());
        } else if (!visible && active) {
          active = false;
          video.pause();
          carousel.resume?.();
        }
      });
    }, {root: carousel.querySelector('slideshow-slides'), threshold: [0,0.7]});
    observer.observe(slide);
  });
}
viyaBindSlideVideos();
document.addEventListener('shopify:section:load', viyaBindSlideVideos);
  } catch(e) { console.error(e); }
})();

})();
